// extracted by mini-css-extract-plugin
module.exports = {"buttonArea":"userBetweenUser_buttonArea__1zKDG"};